// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"5be9b48b","59":"de4fdbf3","78":"5d9cd163","98":"edde23cb","476":"5293a7f2","615":"92f5b04a","747":"6039a142","899":"43364790"}[chunkId] + ".chunk.js";
};